export function cn() {
  return [...arguments]
    .flatMap((arg) => {
      if (!arg) return;
      if (typeof arg === "string" || Array.isArray(arg)) return arg;
      return Object.entries(arg).map(([key, val]) => val && key);
    })
    .filter(Boolean)
    .join(" ");
}

export default function className() {
  return { className: cn(...arguments) };
}
